<template>
  <div class="menu-main">
    <van-nav-bar
      :title="$t('cardPackageTitle')"
      :left-text="$t('returnBtn')"
      v-if="showFood"
      @click-left="showFood = false"
      left-arrow
      :fixed="true"
    />

    <div class="formbox" v-if="!showFood">
      <div class="meal-period" v-if="productCateforyList.length > 0">
        <div
          class="meal-item"
          :class="[mealIndex == index ? 'selectMeal' : '']"
          v-for="(item, index) in mealPeriod"
          :key="index"
          @click="handleSelectMeal(index, item)"
        >
          <div>{{ item.mealHourName }}</div>
          <div>{{ item.mealHourTime }}</div>
          <!-- <div style="background: #2071c5; height: 1px; width: 22px"></div> -->
        </div>
      </div>
      <div class="form">
        <van-form input-align="right">
          <van-field
            :name="$t('workshopNameLabel')"
            :label="$t('workshopNameLabel')"
            v-model="formData.customerName"
            required
            disabled
            :placeholder="$t('workshopNamePlaceholder')"
          />
          <!-- v-model="formData.customerName" -->
          <van-field
            disabled
            name=""
            v-model="formData.payRadio"
            required
            :label="$t('workshopRadioLabel')"
          />
          <van-field
            v-model="formData.address"
            readonly
            required
            @click="selectLocation"
            name=""
            :label="$t('repastAddress')"
            :placeholder="$t('workshopAddress')"
          />
          <van-field
            readonly
            clickable
            name="calendar"
            required
            :value="formData.mealPeriodTime"
            :label="$t('workshopTimeLabel')"
            :placeholder="$t('workshopTimePlaceholder')"
            @click="showCalendar = true"
          />
          <van-calendar
            color="#1989fa"
            v-model="showCalendar"
            type="range"
            :default-date="currentDateRange"
            :max-date="maxDate"
            @confirm="selectDate"
            :allow-same-day="true"
          />

          <van-field
            v-model="shopListLabel"
            @click="selectFood"
            name=""
            required
            :label="$t('workshopDishLabel')"
            :placeholder="$t('workshopAddress')"
          />

          <van-field
            v-model="formData.remark"
            name=""
            :label="$t('remark')"
            maxlength="100"
            :placeholder="$t('orderRemarkTip')"
          />
          <div style="margin: 16px" class="action">
            <div @click="$router.back()">
              <van-button round type="default" style="width: 150px">{{
                $t("orderCancel")
              }}</van-button>
            </div>
            <div @click="submitData()">
              <van-button round type="info" style="width: 150px">{{
                $t("submitBtn")
              }}</van-button>
            </div>
          </div>
        </van-form>
      </div>
    </div>
    <div class="foodbox" v-else>
      <!-- 主体 -->
      <div class="select-menu-main" v-if="productCateforyList.length > 0">
        <!-- 左 -->
        <div class="left-side">
          <div
            v-for="(item, index) in productCateforyList"
            :key="item.categoryId"
          >
            <div
              class="menu-item"
              :class="[selectedMenuId == index ? 'm-item-active' : '']"
              @click="handleChangeLeftSide(index)"
            >
              <div class="m-item-title left-item-title">
                {{ language == "CN" ? item.categoryName : item.categoryNameEn }}
              </div>
            </div>
          </div>
        </div>
        <!-- 右 -->
        <div class="right-side" ref="content">
          <div>
            <div
              v-for="(item, index) in productCateforyList"
              :id="'id' + index"
              :key="item.categoryId"
            >
              <div class="dish-title">
                {{ language == "CN" ? item.categoryName : item.categoryNameEn }}
              </div>
              <div
                class="dish-item"
                v-for="(menu, index) in item.productList"
                :key="index"
              >
                <div class="dish-item-wrp">
                  <div class="dish-item-pic">
                    <img
                      :src="
                        menu.productpic == ''
                          ? require('../../assets/noimg.jpeg')
                          : menu.productpic
                      "
                      alt=""
                    />
                  </div>
                  <div class="dish-item-info">
                    <div class="dish-item-name">
                      {{
                        language == "CN" ? menu.name : menu.nameEn || menu.name
                      }}
                    </div>
                    <div
                      class="dish-item-money"
                      v-if="menu.price == menu.vipprice"
                    >
                      ￥{{ (menu.price / 100).toFixed(2) }}
                    </div>
                    <div class="preferential" v-else>
                      <div class="vipPrice">
                        ¥{{ (menu.vipprice / 100).toFixed(2) }}
                      </div>
                      <div class="menuPrice">
                        ¥{{ (menu.price / 100).toFixed(2) }}
                      </div>
                    </div>
                  </div>
                  <div class="dish-item-count" v-if="menu.productNum > 0">
                    <div
                      class="dish-item-tab"
                      :class="[menu.count > 0 ? 'showMinus' : 'hiddenMinus']"
                      @click.stop="handleMinusCount(menu)"
                    >
                      <img
                        class="count-pic"
                        src="../../assets/imgs/minus.png"
                        alt=""
                      />
                    </div>
                    <div
                      class="dish-item-tab"
                      :class="[menu.count > 0 ? 'showMinus' : 'hiddenMinus']"
                      @click="handleSelectMenuCount(menu)"
                    >
                      {{ menu.count }}
                    </div>
                    <div class="dish-item-tab" @click.stop="handleAdd(menu)">
                      <img
                        class="count-pic"
                        src="../../assets/imgs/madd.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="pay-null" v-else>{{ $t("soldOut") }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="nullImg" v-if="productCateforyList.length == '0'">
        <img
          style="width: 140px; height: 140px"
          src="../../assets/without.png"
          alt=""
        />
      </div>
      <!-- 底部 -->
      <!-- <div class="call-info">
          <span>当前叫号：{{ WaitingISNum }}</span>
          <span class="peo-c">当前人数：{{ peopleNum }}</span>
          <span class="peo-c">预计时间：{{ estimatedTime }}</span>
        </div> -->

      <div class="footer-main" v-if="productCateforyList.length > 0">
        <div class="footImg" @click="handleShowShoping">
          <img src="@/assets/shop.png" alt="" />
          <div
            class="menu-nun"
            v-if="selectMenuCountAll > 0 && selectMenuCountAll < 100"
          >
            {{ selectMenuCountAll }}
          </div>
          <div class="menu-nun" v-if="selectMenuCountAll > 99">99+</div>
          <!-- <div v-else></div> -->
        </div>
        <div class="menu-prompt" v-if="selectShopList.length == 0">
          {{ $t("orderPrompt") }}
        </div>
        <div class="menu-prompt menu-price" v-else>￥{{ computeCount }}</div>
        <div class="place-order active-btn" @click="handleSubmitOrder">
          <!--  v-if="computeSendPrice || countSendPrice == '0'" -->
          {{ $t("confirm") }}
        </div>
        <!-- <div class="place-order" v-else>差{{ countSendPrice }}元起送</div> -->
      </div>
    </div>

    <!-- 购物车弹窗 -->
    <van-popup v-model="shopShow" position="bottom" :style="{ height: '40%' }">
      <div class="shop-main">
        <div class="shop-head">
          <div>{{ $t("selectedGoods") }}</div>
          <div @click="handleClearShop">{{ $t("clearCart") }}</div>
        </div>
        <div class="shop-item" v-for="item in selectShopList" :key="item.id">
          <div class="item-name">
            {{ language == "CN" ? item.name : item.nameEn || item.name }}
          </div>
          <div class="price-count">
            <div class="price" v-if="item.price == item.vipprice">
              ￥{{ ((item.price / 100) * item.count).toFixed(2) }}
            </div>
            <div v-else class="price">
              ￥{{ ((item.vipprice / 100) * item.count).toFixed(2) }}
            </div>
            <div class="selectCount">
              <div
                style="width: 25px; height: 25p; line-height: 0"
                @click="handleLoseShopCount(item)"
              >
                <img
                  style="width: 25px; height: 25px"
                  src="../../assets/imgs/minus.png"
                  alt=""
                />
              </div>
              <div class="num">{{ item.count }}</div>
              <div
                style="width: 25px; height: 25px; line-height: 0"
                @click="handleAddShopCount(item)"
              >
                <img
                  style="width: 25px; height: 25px"
                  src="../../assets/imgs/madd.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <div v-if="selectShopList.length == 0" class="notMenul">
          {{ $t("noSelectShop") }}
        </div>
      </div>
    </van-popup>
    <!-- 设置数量 -->
    <van-dialog
      v-model="showMenuDesciption"
      :title="$t('editNum')"
      show-cancel-button
      @confirm="handleConfirmCount"
    >
      <div style="padding: 12px">
        <van-field
          style="border: 1px solid #eee"
          v-model="placeCount"
          type="digit"
          :placeholder="$t('enterOrderQuantity')"
        />
      </div>
    </van-dialog>
  </div>
</template>
<script>
import utils from "../../utils/filter";
import { Dialog } from "vant";
import dayjs from "dayjs";
export default {
  data() {
    return {
      showSlogan: false,
      weekDay: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      timeIndex: 0,
      mealPeriod: [],
      mealIndex: 0,
      selectMenuCount: null,
      selectedMenuId: 0,
      productCateforyList: [],
      productCateList: [],
      allCateList: [],
      shopShow: false,
      selectShopList: [],
      listBoxState: true,
      dateArr: [], //上方日期
      mealPeriodTime: "",
      selectMealList: [],
      mealHourName: "",
      mealHourTime: "",
      mealHourId: "",
      shopId: "",
      branchId: "",
      branchName: "",
      sendPrice: "",
      totalPrice: "",
      priceMinus: "",
      minusFlag: false,
      searchText: "",
      newList: [],
      showMenuDesciption: false,
      dblCount: 0,
      menuDescription: "",
      placeCount: null,
      selectCountRow: {},
      WaitingISNum: "",
      peopleNum: "",
      estimatedTime: "",
      formData: {
        mealPeriodTime: dayjs().format("YYYY-MM-DD"),
        remark: "",
        customerName: "",
        address: "",
        payRadio: "", // 支付方式
      },
      showCalendar: false,
      showFood: false, // 选择菜品
      groupPayData: [],
      showPicker: false,
      payColumns: [],
      language: "",
      maxDate: new Date(),
      currentDateRange: [new Date(), new Date()], // 记录当前的选择
    };
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.path == "/card/selectBranch" ||
      to.path == "/order/list" ||
      to.path == "/me/index" ||
      to.path == "/nutitron/home" ||
      to.path == "/page"
    ) {
      this.$vnode.parent.componentInstance.cache = {};
      this.$vnode.parent.componentInstance.keys = [];
    }
    next();
  },
  activated() {
    this.selectShopList = [];
    console.log("active", this.$route.params);
    // 存在再来一单
    this.getGroupPay();
    this.language = localStorage.getItem("language");
    this.showFood = false;
    this.placeCount = null;
    this.formData.remark = "";
    if (localStorage.getItem("customerInfoList")) {
      const userInfoList = JSON.parse(localStorage.getItem("customerInfoList"));
      this.formData.customerName =
        this.language == "CN"
          ? userInfoList?.[0]?.username
          : userInfoList?.[0]?.usernameEn;
    }
    if (localStorage.getItem("global-address")) {
      const address = JSON.parse(localStorage.getItem("global-address"));
      this.formData.address = address.allName;
      this.formData.levelNo = address.levelNo;
    }
    this.branchId = sessionStorage.getItem("branchId");
    this.branchName = sessionStorage.getItem("branchName");
    this.shopId = localStorage.getItem("shopId");
    if (this.$route.params.againData) {
      const data = this.$route.params.againData;
      console.log(data, "data---");
      this.formData.mealPeriodTime =
        data.targetDate.split(" ")[0] + "~" + data.targetDate.split(" ")[0];
      this.formData.address = data.addressDetail;
      const globalAddress = {
        allName: data.addressDetail,
        levelNo: data.levelNo,
      };
      this.mealPeriodTime =
        data.targetDate.split(" ")[0] || dayjs().format("YYYY-MM-DD"); //+" "+ week;
      localStorage.setItem("global-address", JSON.stringify(globalAddress));

      this.getMenuList(() => {
        console.log("回调");
        this.productCateforyList.forEach((ele) => {
          ele.productList.forEach((item) => {
            const res = data.orderItemList.find(
              (child) => child.productId == item.id
            );
            console.log(res, "res");
            if (res) {
              item.count = res.quantity;
            }
          });
        });
        console.log(this.productCateforyList, "this.productCateforyList");
      });

      this.selectShopList = data.orderItemList.map((ele) => {
        return {
          ...ele,
          id: ele.productId,
          name: ele.productName,
          count: ele.quantity,
          price: (ele.priceStr - 0) * 100,
          vipprice: (ele.vipPriceStr - 0) * 100,
        };
      });

      return;
    } else {
      this.formData.mealPeriodTime = dayjs().format("YYYY-MM-DD");
      this.mealPeriodTime = dayjs().format("YYYY-MM-DD");
    }
    console.log("over");
    // 切换门店的时候
    if (
      this.$route.query.branchId &&
      this.$route.query.branchId !== this.branchId
    ) {
      this.selectShopList = [];
      this.selectMenuCount = 0;
      for (let i = 0; i < this.productCateforyList.length; i++) {
        for (
          let j = 0;
          j < this.productCateforyList[i].productList.length;
          j++
        ) {
          this.productCateforyList[i].productList[j].count = 0;
        }
      }
      this.getMenuList();
    }
    this.getMenuList();
    let seleciTime = JSON.parse(sessionStorage.getItem("selectTime"));
    if (seleciTime) {
      sessionStorage.setItem("selectTime", JSON.stringify(seleciTime));
    } else {
      sessionStorage.setItem("selectTime", JSON.stringify(this.mealPeriod[0]));
    }
    // this.getGroupPay();
  },
  created() {
    this.showSlogan = true;
    console.log("careate");
    this.branchId = sessionStorage.getItem("branchId");
    this.branchName = sessionStorage.getItem("branchName");
    this.shopId = localStorage.getItem("shopId");
    this.language = localStorage.getItem("language");
    this.timeIndex = 0;
    this.mealIndex = 0;
    this.createTime();
    this.getDataList();
    if (this.$route.params.againData) {
      return;
    }

    this.mealPeriodTime = this.dateArr[0];
    this.getMenuList();
    // this.getQueueUp();
    // this.getWatingNum();
  },
  mounted() {
    console.log("mounted");
    let timeId;
    window.addEventListener(
      "scroll",
      () => {
        // 页面滚动停止100毫秒后才会执行下面的函数。
        clearTimeout(timeId);
        timeId = setTimeout(() => {
          this.scrollToTop();
        }, 100);
      },
      true
    );
  },
  computed: {
    selectMenuCountAll() {
      return this.selectShopList.reduce((a, b) => {
        return a + Number(b.count);
      }, 0);
    },
    computeCount() {
      let allCount = null;
      for (let i = 0; i < this.selectShopList.length; i++) {
        if (this.selectShopList[i].price == this.selectShopList[i].vipprice) {
          allCount +=
            this.selectShopList[i].price * this.selectShopList[i].count;
        } else {
          allCount +=
            this.selectShopList[i].vipprice * this.selectShopList[i].count;
        }
      }
      this.totalPrice = (allCount / 100).toFixed(2);
      return (allCount / 100).toFixed(2);
    },
    computeSendPrice() {
      let minus = this.sendPrice - this.totalPrice * 100;
      if (minus <= 0) {
        this.minusFlag = true;
      } else {
        this.minusFlag = false;
      }
      if (!this.selectShopList.length) {
        this.minusFlag = false;
      }
      return this.minusFlag;
    },
    countSendPrice() {
      this.priceMinus = this.sendPrice - this.totalPrice * 100;
      if (!this.selectShopList.length) {
        this.priceMinus = this.sendPrice;
      }
      return parseInt(this.priceMinus / 100);
    },
    shopListLabel() {
      if (this.selectShopList.length === 0) {
        return this.$t("workshopAddress");
      }
      return this.selectShopList
        .map(
          (ele) =>
            `${this.language == "CN" ? ele.name : ele.nameEn || ele.name}*${
              ele.count
            }`
        )
        .toString();
    },
  },
  methods: {
    getDatesBetween(startDateStr, endDateStr) {
      const dateList = [];
      let current = dayjs(startDateStr);
      const end = dayjs(endDateStr);

      while (current.isBefore(end, "day") || current.isSame(end, "day")) {
        dateList.push(current.format("YYYY-MM-DD"));
        current = current.add(1, "day");
      }
      return dateList;
    },

    submitData() {
      console.log("提交");
      if (this.selectShopList.length === 0) {
        this.$toast(this.$t("noSelectTips"));
        return;
      }
      if (!this.formData.payRadio) {
        this.$toast(this.$t("noneAccount"));
        return;
      }
      if (!this.formData.levelNo) {
        this.$toast("请选择就餐地点");
        return;
      }
      let roles = JSON.parse(localStorage.getItem("customerInfoList"));
      const customerId =
        (roles && roles[0].customerId) || localStorage.getItem("customerId");
      console.log(this.selectShopList, "this.selectShopList");
      const mealPeriodTime = this.formData.mealPeriodTime?.split("~");
      const targetDateData = this.getDatesBetween(
        mealPeriodTime[0],
        mealPeriodTime[1]
      );
      console.log(targetDateData, "targetDateData");

      const params = targetDateData.map((item) => {
        return {
          orderType: "39", // 车间
          reserveType: "3", //外卖
          note: this.formData.remark, // 备注
          levelNo: this.formData.levelNo, // 地址
          branchId: this.branchId,
          branchName: this.branchName,
          shopId: this.shopId,
          customerName: this.formData.customerName, // 预定人
          customerId,
          // customerPhone: this.formData, // 暂无手机号码
          targetDate: item,
          orderDetailList: this.selectShopList.map((ele) => {
            return {
              productId: ele.id,
              productName: this.language == "CN" ? ele.name : ele.nameEn,
              count: ele.count,
              price: ele.price,
              productAmount: ele.count,
              productpic: ele.price || 0,
            };
          }),
          mealHourId: this.mealHourId,
          mealHourName: this.mealHourName,
          mealHourTime: this.mealHourTime,
          warm: false, // 没地方设置，默认值
          meal: false, // 没地方设置，默认值
        };
      });
      const _this = this;
      let dialogMessage = "￥" + this.computeCount * params.length;
      console.log("params", params);
      Dialog.alert({
        allowHtml: true,
        message: dialogMessage,
        showCancelButton: true,
        confirmButtonText: this.$t("confirmPay"),
        confirmButtonColor: "#419DFB",
      })
        .then(async () => {
          this.$toast.loading({
            message: this.$t("paymentIn"),
            forbidClick: true,
            loadingType: "spinner",
          });
          try {
            const targetData = this.groupPayData.find(
              (ele) => ele.payAccountName === this.formData.payRadio
            );
            const createRes = await this.$authAjax.post(
              "/api/wxapp/new/reserve/order/batchCreate",
              {
                orderList: params,
                groupRuleId: targetData.id,
              }
            );
            const { code: createCode, data: createData } = createRes.data || {};
            if (createCode != 200) {
              this.$toast.fail(createRes.data.message);
              return;
            }
            this.$toast.loading({
              message: this.$t('paymentIn'),
              forbidClick: true,
              loadingType: "spinner",
            });
            let createBatchOrderResultList = [];
            let createBatchOrderErrorResultList = [];
            const createOrderResultList = createData.map((item, index) => {
              return {
                ...item,
                index: index,
              };
            });

            createBatchOrderResultList = createOrderResultList
              .filter((item) => item.code === 200)
              .map((item) => {
                return {
                  ...item.data,
                  index: item.index,
                  groupPayRuleId: targetData.id,
                };
              });
            const orderErrorList = createOrderResultList.filter(
              (item) => item.code !== 200
            );
            createBatchOrderErrorResultList = orderErrorList.map((item) => {
              return {
                result: item,
                origin: params[item.index],
                index: item.index,
              };
            });
            // 如果全部失败就弹出提示
            if (createBatchOrderResultList.length === 0) {
              this.handleBatchPayDialog(createBatchOrderErrorResultList);
              return;
            }
            const payReqData = createBatchOrderResultList;
            const payRes = await this.$authAjax.post(
              "/api/wxapp/new/reserve/order/group/batchPay",
              payReqData
            );
            let payData = payRes.data.data || [];
            if (payRes.data.code !== 200) {
              this.$toast.fail(payRes.data.message);
              return;
            }
            payData = payData.map((item, index) => {
              const originIndex = payReqData[index].index;
              const originItem = params[originIndex];
              return {
                result: item,
                origin: originItem,
                index: originIndex,
              };
            });
            const allResultInfoList = [
              ...payData,
              ...createBatchOrderErrorResultList,
            ].sort((a, b) => a.index - b.index);
            // 弹窗显示全部状态
            this.handleBatchPayDialog(allResultInfoList);
            this.$toast.clear();
          } catch(e) {
            this.$toast.clear();
          }
        })
        .catch(() => {
          //this.$toast.success("支付成功");
          // this.$toast.fail("支付失败");
        });
      //
    },
    handleBatchPayDialog(statusList) {
      console.log("statusList", statusList);
      // 这里处理 弹窗
      // 组装
      // time
      // mealHourName
      const dialogHtml = statusList
        .map((item) => {
          const { origin, result } = item;
          const status = result.code == 200 ? "成功" : "失败";
          const statusColor = result.code == 200 ? "#09BB07" : "#F56C6C";
          const message = result.message || "";
          let html = `<p style="display: flex;"><span style="flex: 1">时间：${origin.targetDate}-${origin.mealHourName}</span> <span style="color: ${statusColor}">${status}</span></p>`;
          if (result.code != 200) {
            html += `<p>${message}</p>`;
          }
          return html;
        })
        .join("");

      Dialog.alert({
        title: "提示",
        message: dialogHtml,
        cancelButtonColor: "#999",
        confirmButtonText: "确定",
        confirmButtonColor: "#419DFB",
      })
        .then(() => {
          this.$router.replace({
            // path: "/card/selectNewBranch",
            name: "SelectNewBranch",
            query: {
              type: this.$route.query.type,
            },
            params: {
              isList: true,
            },
          });
        })
        .catch(() => {});
    },
    selectFood() {
      this.showFood = true;
    },
    selectPayRadio(value, index) {
      this.formData.payRadio = value;
      this.showPicker = false;
    },
    selectLocation() {
      console.log("212121");
      this.$router.push({
        name: "address",
      });
    },
    selectDate(date) {
      this.formData.mealPeriodTime =
        dayjs(date[0]).format("YYYY-MM-DD") +
        "~" +
        dayjs(date[1]).format("YYYY-MM-DD");
      console.log(new Date(date).getDay(), "222");
      this.showCalendar = false;
      let weekIndex = new Date(date[0]).getDay();
      let week = this.weekDay[weekIndex];
      this.mealIndex = 0;
      this.mealPeriodTime = dayjs(date[0]).format("YYYY-MM-DD"); //+" "+ week;
      this.getMenuList();
      this.selectShopList = [];
      // this.selectMenuCount = 0;
      this.selectedMenuId = 0;
    },
    getDataList() {
      let data = {
        shopId: this.shopId,
        branchId: this.branchId,
      };
      this.$authAjax
        .post("/api/wxapp/reserve/getReserveMealRule", data)
        .then((res) => {
          const { data } = res.data;
          let dayCount = 7;
          if (res.data.code == 200) {
            dayCount = data.maxDays;
            this.sendPrice = data.minDeliveryAmount;
            sessionStorage.setItem("packPrice", data.packPrice);
            sessionStorage.setItem("deliveryPrice", data.deliveryPrice);
          }
          this.createTime(dayCount);
        });
    },
    //生成时间
    createTime(dayCount) {
      let nowDate = new Date();
      nowDate.setHours(1);
      nowDate.setMinutes(1);
      let dateArr = Array(dayCount)
        .fill(0)
        .map((_, i) => {
          let data = utils.formatDate(nowDate);
          let weekIndex = nowDate.getDay();
          let week = this.weekDay[weekIndex];
          nowDate.setDate(nowDate.getDate() + 1);
          // return data + " " + week;
          return data;
        });
      this.dateArr = dateArr;
      this.maxDate = new Date(this.dateArr[this.dateArr.length - 1]); // new Date(this.dateArr[dayCount - 1])
    },
    //选择日期
    handleChangeTime(index, item) {
      console.log("handleChangeTime");
      this.timeIndex = index;
      this.mealIndex = 0;
      this.mealPeriodTime = item;
      this.getMenuList();
      this.selectShopList = [];
      // this.selectMenuCount = 0;
      this.selectedMenuId = 0;
    },
    //获取菜品餐段及餐段列表
    getMenuList(cb) {
      try {
        this.$toast.loading({
          message: this.language == "CN" ? "加载中..." : "Loading...",
          forbidClick: true,
          loadingType: "spinner",
        });
        this.mealPeriod = [];
        this.productCateforyList = [];
        this.productCateList = [];
        this.allCateList = [];
        let roles = JSON.parse(localStorage.getItem("customerInfoList"));
        const customerId =
          (roles && roles[0].customerId) || localStorage.getItem("customerId");
        let data = {
          shopId: this.shopId,
          branchId: this.branchId,
          customerId: customerId,
          targetDate: this.mealPeriodTime,
        };
        this.$authAjax
          .post("/api/wxapp/reserve/findMenuProducts", data)
          .then((res) => {
            this.$toast.clear();
            const { data } = res.data;
            this.selectMealList = data;
            console.log(data, this.selectMealList, "data");
            const mealPeriod = (data || []).map((item) => {
              return {
                id: item.id,
                mealHourName:
                  this.language == "CN"
                    ? item.mealHourName
                    : item.mealHourNameEn,
                mealHourTime:
                  item.mealHourTime.substring(0, 5) +
                  "-" +
                  item.mealHourTime.substring(11, 16),
              };
            });
            this.mealPeriod = mealPeriod;
            sessionStorage.setItem(
              "selectTime",
              JSON.stringify(this.mealPeriod[0])
            );
            if (this.mealPeriod.length != 0) {
              console.log(this.mealPeriod, 12);
              this.mealHourName = this.mealPeriod[0].mealHourName;
              this.mealHourTime = this.mealPeriod[0].mealHourTime;
              this.mealHourId = this.mealPeriod[0].id;
            }
            if (data != null) {
              this.productCateforyList = data[0].productCateforyList;
              // this.productCateList = JSON.parse(
              // 	JSON.stringify(this.productCateforyList)
              // );
              this.allCateList = JSON.parse(
                JSON.stringify(data[0].productCateforyList)
              );
            }
            cb && cb();
            if (res.data.code != 200) {
              this.$toast(res.data.message);
            }
          });
      } finally {
        this.$toast.clear();
      }
    },
    //选择餐段
    handleSelectMeal(index, item) {
      console.log("index", index, item);

      this.selectShopList = [];
      // this.selectMenuCount = 0;
      this.productCateforyList = [];
      this.mealIndex = index;
      this.mealHourName = item.mealHourName;
      this.mealHourTime = item.mealHourTime;
      this.mealHourId = item.id;
      this.selectMealList.map((item0) => {
        if (
          (this.language == "CN" ? item0.mealHourName : item0.mealHourNameEn) ==
          item.mealHourName
        ) {
          this.productCateforyList = item0.productCateforyList;
          // this.productCateList = JSON.parse(
          //   JSON.stringify(this.productCateforyList)
          // );
          this.allCateList = JSON.parse(
            JSON.stringify(item0.productCateforyList)
          );
        }
      });
      sessionStorage.setItem("selectTime", JSON.stringify(item));
      for (let i = 0; i < this.productCateforyList.length; i++) {
        for (
          let j = 0;
          j < this.productCateforyList[i].productList.length;
          j++
        ) {
          this.productCateforyList[i].productList[j].count = 0;
        }
      }
    },
    //改变左边side栏
    handleChangeLeftSide(index) {
      this.selectedMenuId = index;
      this.$el.querySelector(`#id${index}`).scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start", // 上边框与视窗顶部平齐。默认值
      });
      this.listBoxState = false;

      let timeId;
      clearTimeout(timeId);
      timeId = setTimeout(() => {
        this.listBoxState = true;
      }, 1000);
    },
    //滚动右侧事件
    scrollToTop() {
      var domHight = document.body.offsetHeight;
      // dom滚动位置
      // var scrollTop =
      let scrollTop = this.$refs.content.scrollTop;
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;
      if (this.listBoxState) {
        this.productCateforyList.forEach((v, i) => {
          // 获取监听元素距离视窗顶部距离
          var offsetTop = document.getElementById(`id${i}`).offsetTop;
          // 获取监听元素本身高度
          var scrollHeight = document.getElementById(`id${i}`).scrollHeight;
          // 如果 dom滚动位置 >= 元素距离视窗距离 && dom滚动位置 <= 元素距离视窗距离+元素本身高度
          // 则表示页面已经滚动到可视区了。
          if (scrollTop >= offsetTop && scrollTop <= offsetTop + scrollHeight) {
            // 导航栏背景色选中
            this.selectedMenuId = i;
          }
        });
      }
    },
    //增加数量
    handleAdd(data) {
      console.log(data, "add item");
      if (data.count >= data.productNum) {
        return this.$toast(this.$t("Insufficient"));
      }
      if (
        data.productPurchasingNum != 0 &&
        data.count >= data.productPurchasingNum
      ) {
        return this.$toast(this.$t("purchaseLimit"));
      }
      data.count++;
      // this.selectMenuCount++;
      this.selectShopList = [];
      // for (let i = 0; i < this.productCateList.length; i++) {
      // 	for (let j = 0; j < this.productCateList[i].productList.length; j++) {
      // 		if (this.productCateList[i].productList[j].id == data.id) {
      // 			this.productCateList[i].productList[j].count = data.count;
      // 		}
      // 		if (this.productCateList[i].productList[j].count > 0) {
      // 			this.selectShopList.push(this.productCateList[i].productList[j]);
      // 		}
      // 	}
      // }
      for (let i = 0; i < this.productCateforyList.length; i++) {
        for (
          let j = 0;
          j < this.productCateforyList[i].productList.length;
          j++
        ) {
          if (this.productCateforyList[i].productList[j].id == data.id) {
            this.productCateforyList[i].productList[j].count = data.count;
          }
        }
      }
      const newSelectList = this.productCateforyList.map((ele) => {
        return ele.productList.filter((item) => item.count);
      });
      console.log(newSelectList, "newSelectList");
      this.selectShopList = [].concat(...newSelectList);
      // for (let i = 0; i < this.selectShopList.length; i++) {
      // 	for (let j = 1; j < this.selectShopList.length; j++) {
      // 		if (
      // 			this.selectShopList[i].id == this.selectShopList[j].id &&
      // 			i !== j
      // 		) {
      // 			this.selectShopList[i].count = this.selectShopList[j].count;
      // 			this.selectShopList.splice(j, 1);
      // 		}
      // 	}
      // }
      console.log(this.productCateforyList, "productCateforyList");
      console.log(this.selectShopList, "selectShopList");
    },
    //减少数量
    handleMinusCount(data) {
      if (data.count == "0") {
        return;
      }
      data.count--;
      // this.selectMenuCount--;
      // for (let i = 0; i < this.productCateList.length; i++) {
      // 	for (let j = 0; j < this.productCateList[i].productList.length; j++) {
      // 		if (this.productCateList[i].productList[j].id == data.id) {
      // 			this.productCateList[i].productList[j].count = data.count;
      // 		}
      // 	}
      // }
      for (let i = 0; i < this.productCateforyList.length; i++) {
        for (
          let j = 0;
          j < this.productCateforyList[i].productList.length;
          j++
        ) {
          if (this.productCateforyList[i].productList[j].id == data.id) {
            this.productCateforyList[i].productList[j].count = data.count;
          }
        }
      }
      // if (data.count == 0) {
      // 	let index = this.selectShopList.findIndex((item) => {
      // 		return data.id == item.id;
      // 	});
      // 	this.selectShopList.splice(index, 1);
      // }
      const newSelectList = this.productCateforyList.map((ele) => {
        return ele.productList.filter((item) => item.count);
      });
      console.log(newSelectList, "newSelectList");
      this.selectShopList = [].concat(...newSelectList);

      if (!this.selectShopList.length) {
        this.priceMinus = this.sendPrice;
        this.minusFlag = false;
      }
    },
    //弹出购物车
    handleShowShoping() {
      this.shopShow = true;
    },
    //减少购物车数量
    handleLoseShopCount(item) {
      item.count--;
      // this.selectMenuCount--;
      for (let i = 0; i < this.productCateforyList.length; i++) {
        for (
          let j = 0;
          j < this.productCateforyList[i].productList.length;
          j++
        ) {
          if (this.productCateforyList[i].productList[j].id == item.id) {
            this.productCateforyList[i].productList[j].count = item.count;
          }
        }
      }
      // for (let i = 0; i < this.productCateList.length; i++) {
      // 	for (let j = 0; j < this.productCateList[i].productList.length; j++) {
      // 		if (this.productCateList[i].productList[j].id == item.id) {
      // 			this.productCateList[i].productList[j].count = item.count;
      // 		}
      // 	}
      // }
      if (item.count == 0) {
        let index = this.selectShopList.findIndex((data) => {
          return item.id == data.id;
        });
        this.selectShopList.splice(index, 1);
      }
    },
    //增加购物车数量
    handleAddShopCount(item) {
      if (item.count >= item.productNum) {
        return this.$toast(this.$t("Insufficient"));
      }
      if (
        item.productPurchasingNum != 0 &&
        item.count >= item.productPurchasingNum
      ) {
        return this.$toast(this.$t("purchaseLimit"));
      }
      item.count++;
      // this.selectMenuCount++;
      for (let i = 0; i < this.productCateforyList.length; i++) {
        for (
          let j = 0;
          j < this.productCateforyList[i].productList.length;
          j++
        ) {
          if (this.productCateforyList[i].productList[j].id == item.id) {
            this.productCateforyList[i].productList[j].count = item.count;
          }
        }
      }
      console.log("购物车");
      const newSelectList = this.productCateforyList.map((ele) => {
        return ele.productList.filter((item) => item.count);
      });
      this.selectShopList = [].concat(...newSelectList);
      console.log(this.selectShopList, "selectShopList");

      // for (let i = 0; i < this.productCateList.length; i++) {
      // 	for (let j = 0; j < this.productCateList[i].productList.length; j++) {
      // 		if (this.productCateList[i].productList[j].id == item.id) {
      // 			this.productCateList[i].productList[j].count = item.count;
      // 		}
      // 	}
      // }
    },
    //清空购物车
    handleClearShop() {
      this.selectShopList = [];
      // this.selectMenuCount = 0;
      for (let i = 0; i < this.productCateforyList.length; i++) {
        for (
          let j = 0;
          j < this.productCateforyList[i].productList.length;
          j++
        ) {
          this.productCateforyList[i].productList[j].count = 0;
        }
      }

      // for (let i = 0; i < this.productCateList.length; i++) {
      // 	for (let j = 0; j < this.productCateList[i].productList.length; j++) {
      // 		this.productCateList[i].productList[j].count = 0;
      // 	}
      // }
    },
    //去下单
    handleSubmitOrder() {
      // if (!this.selectMenuCount) {
      // 	return this.$toast("未选购任何菜品");
      // }
      this.showFood = false;
      // sessionStorage.setItem("mealList", JSON.stringify(this.selectShopList));
      // this.$router.push({
      // 	path: "/order/submit",
      // 	query: {
      // 		mealPeriodTime: this.mealPeriodTime,
      // 		mealHourName: this.mealHourName,
      // 		mealHourTime: this.mealHourTime,
      // 		branchId: this.branchId,
      // 		branchName: this.branchName,
      // 		type: this.$route.query.type,
      // 	},
      // });
    },
    // 筛选菜品
    // handleInputData() {
    // 	let newDataList = JSON.parse(JSON.stringify(this.productCateList));
    // 	this.productCateforyList = newDataList.filter((item) => {
    // 		item.productList = item.productList.filter((resData) => {
    // 			return resData.name.includes(this.searchText);
    // 		});
    // 		return item;
    // 	});
    // },
    // 选择菜品数量
    handleSelectMenuCount(item) {
      if (!item.count) return;
      this.selectCountRow = item;
      this.showMenuDesciption = true;
    },
    handleConfirmCount() {
      if (this.placeCount >= this.selectCountRow.productNum) {
        return this.$toast(this.$t("Insufficient"));
      }
      this.selectMenuCount =
        this.selectMenuCount -
        this.selectCountRow.count +
        Number(this.placeCount);
      this.selectShopList = [];
      this.selectCountRow.count = this.placeCount;
      // for (let i = 0; i < this.productCateList.length; i++) {
      // 	for (let j = 0; j < this.productCateList[i].productList.length; j++) {
      // 		if (
      // 			this.productCateList[i].productList[j].id == this.selectCountRow.id
      // 		) {
      // 			this.productCateList[i].productList[
      // 				j
      // 			].count = this.selectCountRow.count;
      // 		}
      // 		if (this.productCateList[i].productList[j].count > 0) {
      // 			this.selectShopList.push(this.productCateList[i].productList[j]);
      // 		}
      // 	}
      // }
      for (let i = 0; i < this.productCateforyList.length; i++) {
        for (
          let j = 0;
          j < this.productCateforyList[i].productList.length;
          j++
        ) {
          if (
            this.productCateforyList[i].productList[j].id ==
            this.selectCountRow.id
          ) {
            this.productCateforyList[i].productList[j].count =
              this.selectCountRow.count;
          }
        }
      }
      // for (let i = 0; i < this.selectShopList.length; i++) {
      // 	for (let j = 1; j < this.selectShopList.length; j++) {
      // 		if (
      // 			this.selectShopList[i].id == this.selectShopList[j].id &&
      // 			i !== j
      // 		) {
      // 			this.selectShopList[i].count = this.selectShopList[j].count;
      // 			this.selectShopList.splice(j, 1);
      // 		}
      // 	}
      // }
      const newSelectList = this.productCateforyList.map((ele) => {
        return ele.productList.filter((item) => item.count);
      });
      this.selectShopList = [].concat(...newSelectList);
      console.log(this.selectShopList, "selectShopList");
      this.placeCount = null;
    },
    // 获取挂帐账号
    getGroupPay() {
      this.$authAjax
        .get("/api/wxapp/customer/groupPayAccount/list")
        .then((res) => {
          let { data } = res.data;
          this.groupPayData = data;
          this.payColumns = data.map((ele) => {
            return ele.payAccountName;
          });
          this.formData.payRadio = this.payColumns.length
            ? this.payColumns[0]
            : "";
        });
    },
    // 获取排队人数
    async getQueueUp() {
      try {
        const { data } = await this.$authAjax.post(
          "/api/wxapp/new/reserve/order/call/waiting/count",
          {
            shopId: this.shopId,
            branchId: this.branchId,
          }
        );
        if (data.code == 200) {
          let resData = data.data;
          this.peopleNum = resData.count || 0;
          this.estimatedTime = resData.count * 0.5 || 0;
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 获取叫号号码
    async getWatingNum() {
      try {
        const { data } = await this.$authAjax.post(
          "/api/wxapp/new/reserve/order/call/list/query",
          {
            shopId: this.shopId,
            branchId: this.branchId,
          }
        );
        if (data.code == 200) {
          const num = data.callingList?.[0];
          this.WaitingISNum = num ? num : "001";
        }
      } catch (err) {
        console.log(err);
      }
    },
    navBack() {
      this.$router.push({
        name: "SelectNewBranch",
      });
    },
    getTitle() {
      // $route.meta.title
      if (this.showFood) {
        return "选择菜品";
      } else {
        return this.$route.meta.title;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.foodbox {
  padding-top: 48px;
}
.menu-main {
  font-size: 16px;
  box-sizing: border-box;
  overflow: hidden;
  // padding-top: 48px;
  //头部时间选择
  .head-tabar {
    height: 48px;
    background-color: #0686cb;
    display: flex;
    align-items: center;
    margin-top: 45px;
    .time-item {
      margin: 0 6px;
      border-radius: 5px;
      width: 40px;
      height: 40px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      font-size: 12px;
      color: #ffffff;
      text-align: center;
    }
    .selectTime {
      background: #023f86;
      color: #fff;
    }
  }
  //餐段选择
  .meal-period {
    height: 40px;
    display: flex;
    background-color: #ffffff;
    border-bottom: 1px solid #f9f9f9;
    .meal-item {
      width: 25%;
      color: #cccccc;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
    .selectMeal {
      color: #2ab1e7;
      font-size: 14px;
    }
  }
  .search-main {
    padding: 0 16px;
    ::v-deep .van-search {
      padding: 0;
    }
  }
  //主体
  .select-menu-main {
    height: calc(100vh - 120px);
    overflow: hidden;
    display: flex;
    .left-side {
      display: flex;
      width: 100px;
      padding-bottom: 40px;
      background-color: #f0f0f0;
      flex-direction: column;
      border-right: 1px solid #f4f5f6;
      overflow: auto;
      .menu-item {
        width: 78px;
        padding: 12px 0;
        color: #666;
        text-align: center;
        translate: all 0.2s;
        font-size: 14px;
      }
      .left-item-title {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
      }
      .m-item-active {
        background-color: #ffffff;
        color: #2ab1e7;
        position: relative;
        border-radius: 0 -20px 0 -20px;
        &::after {
          content: "";
          width: 4px;
          height: 28px;
          background-color: #2ab1e7;
          position: absolute;
          left: 0;
          top: calc(50% - 14px);
        }
        .m-item-title {
          color: #4ca1fb;
          font-weight: bold;
        }
      }
    }
    #rightTop {
      position: relative;
    }
    .right-side {
      width: 100%;
      padding-bottom: 40px;
      overflow: auto;
      .dish-title {
        font-size: 14px;
        color: #565754;
        border-bottom: 1px solid #f9f9f9;
        padding: 7px 0;
        margin-bottom: 3px;
        padding-left: 12px;
        position: sticky;
        top: 0;
        background-color: #fff;
        z-index: 2;
      }
      .dish-item {
        width: 95%;
        padding: 8px 0;
        padding-left: 12px;
        border-bottom: 1px solid #f4f5f6;
        &-wrp {
          width: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
          // justify-content: space-around;
        }
        &-pic {
          width: 85px;
          height: 85px;
          img {
            width: 85px;
            height: 85px;
            margin: 0 auto;
            border-radius: 5px;
          }
        }
        &-info {
          width: 80px;
          padding-left: 12px;
          // margin-left: -5px;
          position: relative;
        }
        &-name {
          color: #333333;
          font-size: 14px;
          font-weight: bold;
          word-break: break-word;
        }
        &-sales {
          color: #999;
          font-size: 10px;
          margin-top: 6px;
        }
        &-money {
          color: #333333;
          font-size: 16px;
          font-weight: bold;
          margin-top: 8px;
        }
        .preferential {
          display: flex;
          align-items: center;
          .vipPrice {
            font-size: 17px;
            font-weight: bold;
            color: #ff1a1a;
            line-height: 19px;
          }
          .menuPrice {
            font-size: 12px;
            font-weight: 400;
            color: #b0b0b0;
            line-height: 19px;
            text-decoration: line-through;
            margin-left: 6px;
          }
        }
        &-count {
          // margin-left: 5px;
          padding-left: 10px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          .count-pic {
            width: 25px;
            height: 25px;
          }
          div:nth-child(2) {
            color: #ccc;
            font-size: 14px;
            line-height: 25px;
            text-align: center;
            // margin: 0 8px;
          }
        }
        .pay-null {
          font-size: 14px;
          font-weight: 300;
          color: #c0c0c0;
          line-height: 16px;
          margin-left: 26px;
        }
        &-tab {
          width: 25px;
          height: 25px;
        }
        .showMinus {
          opacity: 1;
        }
        .hiddenMinus {
          opacity: 0;
        }
      }
    }
  }

  .nullImg {
    margin: auto;
    width: 175px;
    height: 175px;
    margin-top: 150px;
  }
  //底部
  .call-info {
    width: 100%;
    padding: 6px 0;
    background: #e8f3ff;
    position: fixed;
    bottom: 50px;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 25px;
    z-index: 3;
    span {
      font-weight: 500;
      font-size: 10px;
      color: #333333;
    }
    .peo-c {
      color: #f65a5a;
    }
  }

  .footer-main {
    width: 100%;
    height: 50px;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #fff;
    border-top: 1px solid #f9f9f9;
    z-index: 999;
    .footImg {
      position: absolute;
      top: -50%;
      left: 2%;
      img {
        width: 60px;
        height: 60px;
      }
    }
    .menu-nun {
      display: inline-block;
      // width: 18px;
      height: 16px;
      font-size: 11px;
      color: white;
      padding: 0 5px;
      line-height: 16px;
      border-radius: 25px;
      text-align: center;
      position: absolute;
      right: 5px;
      background: red;
    }
    .menu-prompt {
      color: #999999;
      font-size: 12px;
      display: inline-block;
      padding-left: 75px;
      line-height: 50px;
    }
    .menu-price {
      font-size: 20px;
      color: #ed7e05;
    }
    .place-order {
      width: 100px;
      display: block;
      height: 34px;
      line-height: 34px;
      font-size: 16px;
      background: #d4effa;
      color: #82cce9;
      text-align: center;
      border-radius: 20px;
      position: absolute;
      right: 8px;
      top: 50%;
      transform: translateY(-50%);
    }
    .active-btn {
      background: #2aafe4;
      color: #ffffff;
    }
  }
  //购物车弹窗
  .shop-main {
    width: 100%;
    // padding: 10px 10px 0 10px;
    box-sizing: border-box;
    .shop-head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      line-height: 40px;
      padding: 0 10px;
      border-bottom: 1px solid #ccc;
      position: sticky;
      top: 0;
      background: #fff;
      div:nth-child(2) {
        color: #4ca1fb;
      }
    }
    .shop-item {
      height: 50px;
      line-height: 50px;
      padding: 0 10px;
      border-bottom: 1px solid #ccc;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .price-count {
        display: flex;
        align-items: center;
        .price {
          margin-right: 25px;
        }
        .selectCount {
          display: flex;
          align-items: center;
          .num {
            width: 25px;
            height: 25px;
            line-height: 25px;
            text-align: center;
            color: #ccc;
          }
        }
      }
    }
    .notMenul {
      text-align: center;
      margin-top: 20px;
    }
  }
}
.dialog-explice {
  min-height: 120px;
  padding: 10px;
  box-sizing: border-box;
  .text {
    font-size: 18px;
    display: flex;
    margin-top: 8px;
    line-height: 26px;
    .title {
      white-space: nowrap;
    }
  }
}
.menu-decritipn {
  padding: 12px;
  line-height: 28px;
}
.action {
  display: flex;
  justify-content: space-between;
  > div:first-child {
  }
  > div:last-child {
  }
}
</style>
